import './wia-video-popup.html';
import WiaVideoPopup from './wia-video-popup.js';

export default WiaVideoPopup;



// WEBPACK FOOTER //
// ./home/en-US/js/wia-video-popup/index.js